import themes from './themes/index';

const currentTheme = 'main';

// Set false for production
const isDev = false;
const isUnderMaintenance = false;

export const theme = themes[currentTheme];

export { isDev, isUnderMaintenance };
